import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Transition from 'react-transition-group/Transition';
import { reDraw } from '../../../helpers/common';
import { propBool, propChildren, propFunc, propStr, } from '../../../helpers/custom-prop-types';
import LoginAlertRegistrationCard from '../Card/LoginAlertRegistrationCard';
const RegistrationAlertModal = (props) => {
    const { isShow, newHeaderDescription, newHeaderTitle, onClickOther, onSubmitEvent, registrationType, } = props;
    return (_jsx(Transition, Object.assign({ in: isShow, mountOnEnter: true, onEnter: reDraw, timeout: 500, unmountOnExit: true }, { children: (state) => (_jsxs("div", Object.assign({ className: `alert-card-modal-background is-registration-warning animated-opacity ${state}` }, { children: [_jsx("div", { className: `alert-card-modal-background-bg animated-opacity ${state}`, onClick: onClickOther, role: 'presentation' }), _jsx(LoginAlertRegistrationCard, { newHeaderDescription: newHeaderDescription, newHeaderTitle: newHeaderTitle, onSubmitEvent: onSubmitEvent, registrationType: registrationType })] }))) })));
};
RegistrationAlertModal.propTypes = {
    isShow: propBool().isRequired,
    newHeaderDescription: propChildren(),
    newHeaderTitle: propChildren(),
    onClickOther: propFunc().isRequired,
    onSubmitEvent: propFunc(),
    registrationType: propStr().isRequired,
};
RegistrationAlertModal.defaultProps = {
    newHeaderDescription: undefined,
    newHeaderTitle: undefined,
    onSubmitEvent: undefined,
};
export default RegistrationAlertModal;
